import { render, staticRenderFns } from "./SectionFeatures.vue?vue&type=template&id=664acd6b&scoped=true"
import script from "./SectionFeatures.vue?vue&type=script&lang=ts"
export * from "./SectionFeatures.vue?vue&type=script&lang=ts"
import style0 from "./SectionFeatures.vue?vue&type=style&index=0&id=664acd6b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "664acd6b",
  null
  
)

export default component.exports